import { usePageSeo } from "../lib/seo";

// Renders nothing; sets the page title, meta description and canonical URL.
const Seo = ({ title, description }) => {
    usePageSeo(title, description);
    return null;
};

export default Seo;
